import StoresService from '@services/stores-service.js'

export const state = {
    stores: [],
    selectedStoreId: null,
}

export const mutations = {
    SET_STORE(state, stores) {
        state.stores = stores
    },
    SELECT_STORE(state, storeId) {
        state.selectedStoreId = storeId
    },
}

export const getters = {
    stores: state => state.stores,
    selectedStore: (state, getters) =>
        state.stores.filter(store => store._id === getters.selectedStoreId)[0],
    selectedStoreId: state => state.selectedStoreId,
}

export const actions = {
    async getStores({ commit }) {
        const { stores } = await StoresService.getStores()
        const localStoreId = localStorage.getItem('user.storeId')
        commit('SET_STORE', stores)
        commit('SELECT_STORE', localStoreId || (stores[0] && stores[0]._id))

        return stores
    },

    selectStore({ commit }, storeId) {
        localStorage.setItem('user.storeId', storeId)
        commit('SELECT_STORE', storeId)
    },
}
